import { format } from 'date-fns';
import { isDate } from 'lodash';
import moment from 'moment';

const weekDay = {
  Mo: 'Пн',
  Tu: 'Вт',
  We: 'Ср',
  Th: 'Чт',
  Fr: 'Пт',
  Sa: 'Сб',
  Su: 'Нд',
};

const formatDate = (date: string | Date) => {
  const d = isDate(date) ? date : new Date(date);
  const dayNum = format(d, 'dd.MM.yyyy');
  const dayName = format(d, 'EEEEEE');
  // @ts-ignore
  return `${dayNum} (${weekDay[dayName]})`;
};

const formatTime = (date: string | Date) => {
  const d = isDate(date) ? date : new Date(date);

  return format(d, 'HH:mm');
};

const generateTimes = ({ startVisible, endVisible, slotDurationInMinutes }: any) => {
  const startHours = new Date(startVisible).getHours();

  const startMins = new Date(startVisible).getMinutes();
  let startDate = new Date().setHours(startHours, startMins);

  const endHours = new Date(endVisible).getHours();
  const endMins = new Date(endVisible).getMinutes();
  const endDate = new Date().setHours(endHours, endMins);

  // const dif = Math.floor((endDate - startDate) / (1000 * 60 * 60)) % 24;

  const dates = [];

  let bb;
  if (slotDurationInMinutes === 15) {
    bb = moment(endVisible).diff(moment(startVisible), 'minutes') / 15;
  }
  if (slotDurationInMinutes === 30) {
    bb = (Math.floor((endDate - startDate) / (1000 * 60 * 60)) % 24) * 2;
  }
  if (slotDurationInMinutes === 45) {
    bb = Math.round(((endHours - startHours) * 60) / 45);
  }
  if (slotDurationInMinutes === 60) {
    bb = Math.floor((endDate - startDate) / (1000 * 60 * 60)) % 24;
  }

  dates.push(format(startDate, 'HH:mm'));

  // 48 - сутки
  // @ts-ignore
  // eslint-disable-next-line
  for (let aa = 0; aa < bb; aa++) {
    const d = new Date(startDate);
    d.setMinutes(d.getMinutes() + slotDurationInMinutes);
    dates.push(formatTime(d));
    // @ts-ignore
    startDate = d;
  }

  return dates;
};

export default {
  formatDate,
  formatTime,
  generateTimes,
};
